module.exports = __webpack_public_path__ + "img/grey-t-shirt.56f1eacc.jpg";